import { connect } from "react-redux";

import { updateNote, addNote } from "~/store/ducks/user/notes";
import { selectNoteById } from "~/store/ducks/user/notes";
import { selectDisplayedPages } from "~/store/selectors/page";
import { selectAbsolutePage } from "~/store/ducks/user/uistate";
import { selectTitle } from "~/store/ducks/domain/config";

import NotesModal from "./NotesModal";

const mapStateToProps = (state, ownProps) => ({
  note: selectNoteById(ownProps.noteId)(state),
  displayedPages: selectDisplayedPages(state),
  absolutePage: selectAbsolutePage(state),
  bookTitle: selectTitle(state)
});

const mapDispatchToProps = {
  updateNote,
  addNote
};

export default connect(mapStateToProps, mapDispatchToProps)(NotesModal);
